import Vue from "vue";
import App from "./App.vue";
// import "./assets/css/tailwind.css";
import "tailwindcss/tailwind.css"
import "./styles/index.scss";

import router from "./router";
import store from "./store";
import i18n from './i18n/index';

// 引入 vue-plyr
import VuePlyr from 'vue-plyr'
// 引入 vue-plyr 的样式
import 'vue-plyr/dist/vue-plyr.css'

const { mockXHR } = require("../mock");
mockXHR();
import { Toast } from 'vant';

Vue.config.productionTip = false;
import '@vant/touch-emulator';

Vue.use(Toast);
// 您可以传入默认的 Plyr 选项和国际化语言
Vue.use(VuePlyr, {
  plyr: {}
})
new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
